export const officers = [
  {
    name: "Leul Dagnachew",
    position: "President",
    email: "leuldagnachew@utexas.edu",
    linkedin: "https://www.linkedin.com/in/leul-dagnachew/",
    image: 'leul'
  },
  {
    name: "Franklin Awuah Asamoah",
    position: "Treasurer",
    email: "",
    linkedin: "",
    image: 'Franklin'
  },
  {
    name: "Beatrice Olaosebikan",
    position: "Corporate",
    email: "",
    linkedin: "",
    image: 'Beatrice'
  },
  {
    name: "Enny",
    position: "Public Relations",
    email: "",
    linkedin: "",
    image: 'enny'
  },
  {
    name: "Chinonso Ogwudu",
    position: "Social",
    email: "Chinonso.u.ogwudu@gmail.com",
    linkedin: "linkedin.com/in/chinonso-u-ogwudu/",
    image: 'Chinonso'
  },
  {
    name: "Nanami Buchanan",
    position: "Webmaster JO",
    email: "",
    linkedin: "https://www.linkedin.com/in/nanami-buchanan/",
    image: 'Nanami'
  },
  {
    name: "Angel Ogungbemi",
    position: "Webmaster",
    email: "angel-ogungbemi@utexas.edu",
    linkedin: "https://www.linkedin.com/in/angel-ogungbemi/",
    image: 'angel'
  }
]